<template>
    <div class="private-and-policy">
        <header-comp bgColor="green"></header-comp>
        <div class="private-and-policy-wrap">
            <div class="title-block">
                <h1>會員條款</h1>
                <span class="update-date">更新於 2020 - 11 - 23</span>
                <div class="description">
                    親愛的使用者您好，歡迎您使用本平台，請您詳細閱讀、理解並同意下列「會員條款」與「隱私權政策」所有內容，並申請註冊會員通過後，即可正式使用本平台會員服務。
                </div>
            </div>
            <div class="content-block">
                <h2>會員條款</h2>
                <span class="description">認識與同意會員服務條款</span>
                <ul class="list">
                    <li>
                        1. 本平台會員服務（以下簡稱「本服務」）係由方居浩斯科技股份有限公司（以下簡稱「本公司」）所建置提供，提供會員於本平台(以下或稱「本系統」)使用本服務，所有使用本服務的使用者(以下稱會員)，都應該詳細閱讀下列約定條款。當您完成會員註冊、或開始使用本服務時，即表示您已詳細閱讀、瞭解並同意接受本服務條款之所有內容。
                    </li>
                    <li>
                        2. 本服務條款訂立的目的，是為了保護本服務的提供者以及所有會員的權益，並與會員之間成立服務契約，公告內容與系統內說明亦為本條款之一部分。本公司有權隨時就本服務條款之內容進行修改或變更，並得以於本系統服務公告之，不再個別通知會員，建議您隨時注意本服務條款之修改、變更與系統服務公告。倘您於服務條款修改、變更或公告後仍繼續使用本服務，即表示您已閱讀、瞭解並同意接受本服務條款之修改或變更。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>會員註冊注意事項</h2>
                <span class="description">為確保交易安全與您的權益，請您同意以下註冊相關事項</span>
                <ul class="list">
                    <li>
                        1. 本服務提供採用會員制，申請者須填寫手機號碼、電子郵件與相關資訊註冊為會員並登入後始得使用本系統提供之各項服務。註冊時應填寫正確、最新的資料，不可有提供偽造或變造之資料、進行重複註冊或以他人名義註冊等不當情事，並同意本系統於提供本服務必要範圍內得以收集、保存、利用相關資訊。
                    </li>
                    <li>
                        2. 為保障交易安全與維護會員權益，若您本人不具有完全行為能力(包括未成年人、受監護宣告或受輔助宣告等)，本系統有權婉拒您的註冊申請或透過系統停用您的帳號與使用本服務之全部或一部之權限或終止雙方法律關係。
                    </li>
                    <li>
                        3. 為提供會員最佳的服務，您保證與聲明填寫之資訊均為正確、最新，如已過時或錯誤應迅速更新或更正該過時或不正確資訊。若您重複註冊、使用他人名義註冊、填寫任何錯誤或不實的資料或欠缺必要之資料或未有更新時:
                        <ul>
                            <li>( 1 )	本系統有權拒絕您的註冊、或於不經事先通知您即逕行透過系統暫停您的帳號與使用本服務之全部或一部之權限或終止本條款</li>
                            <li>( 2 )	若造成自身損害您應自行承擔，包括但不限於您因填寫錯誤或未實際使用電子郵件導致未能收到本公司寄發之電子發票或其他電子文件等情事。</li>
                            <li>( 3 )	若造成其他會員或第三人損害，您應自行負擔相應之法律責任，與本系統或本公司無涉。</li>
                            <li>( 4 )	若造成本系統或本公司損害，您應負擔相應之法律責任，本公司將保留相關法律訴追之權利。</li>
                        </ul>
                    </li>
                    <li>
                        4. 您同意本系統所為之通知均以您申請本服務時所提供之通訊資料為準；相關通訊資料如有變更，您應立即於本系統更新或修改。如您提供之通訊資料為錯誤或未依規定方式更新通訊資料時，本系統依原留存之通訊資料所為之通知均視為已送達。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>會員服務內容</h2>
                <ul class="list">
                    <li>
                        1. 您正式註冊成為會員後，本公司將依本系統當時所建置的服務、項目、內容、狀態及功能，提供會員服務；本公司保留隨時變更服務項目與內容之權利，變更後之服務項目與內容，經公佈於本系統或相關網頁後，不另行個別通知會員。
                    </li>
                    <li>
                        2. 目前本服務提供為部分功能免費部分功能收費，詳細收費事項請參考本系統版本公告或本系統版本說明；本公司保留隨時變更免費服務為收費服務、變更收費標準之權利，變更後之內容，經公佈或實裝於本系統或相關網頁後，將不再另行個別通知會員。
                    </li>
                    <li>
                        3. 本系統將提供各會員一組專屬帳號與各次登錄隨機簡訊驗證碼，主要提供會員進行租屋廣告刊登、批量刊登廣告、紙本合約線上化、收支報表查詢、發出帶看屋委託、房客評價等相關服務，詳細服務內容依使用當時本系統版本內容與說明為主。
                    </li>
                    <li>
                        4. 本系統提供會員廣告服務、電子平台服務，均依據會員操作指示或徵得會員同意始進行相關免費或付費服務提供；租屋契約關係存在於簽約會員即房東房客之間，本系統非租屋當事人、租屋仲介或相關類似身分人員，不保證廣告內容、房源實況與會員履行。
                    </li>
                    <li>
                        5. 本系統提供會員第三方支付服務，僅於系統功能需求下提供代收付金融帳號，並將相應代收付款項代為收付保管後根據會員要求、約定或系統設定移交會員指定或應收取之金融帳號，操作過程會員均應確認所有相關資訊(特別是代收付金額、金融帳號)之正確性，如因會員操作錯誤或動機錯誤等情事致使自身或第三人受有損害，會員應自行承擔風險或法律責任。
                    </li>
                    <li>
                        6. 若會員於服務項目、收費模式等內容進行修改、變更或公告後仍繼續使用本服務，視為會員已閱讀、瞭解並同意接受本服務條款之修改或變更。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>會員個人資料保護</h2>
                <ul class="list">
                    <li>
                        1. 關於您所登錄或留存之個人資料及其他特定資料，悉依「隱私權政策」受到保護與規範。本公司將依據相關規範持續基於營運所需於中華民國(台灣)內為使用與保管，直至您提出停止使用本系統或本系統終止提供服務日為止。
                    </li>
                    <li>
                        2. 本公司將依據相關規範持續保密您提供的個人資料，惟在下列情形，本公司有可能會查看或提供會員的個人資料或相關電信資料給相關政府機關、或主張其權利受侵害並提出適當證明之第三人：
                        <ul>
                            <li>( 1 )	依法令規定、或依司法機關或其他相關政府機關的命令；</li>
                            <li>( 2 )	會員涉及違反法令、侵害第三人權益、或違反本使用條款或各該使用規範或約定；</li>
                            <li>( 3 )	保護會員服務系統之安全或經營者之合法權益；</li>
                            <li>( 4 )	為保護其他使用者或其他第三人的合法權益；</li>
                            <li>( 5 )	為維護本系統的正常運作。</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>使用注意事項</h2>
                <ul class="list">
                    <li>
                        1. 您正式註冊成為會員後，將取得一組專屬帳號與各次登錄隨機簡訊驗證碼，您同意並瞭解維持簡訊碼之機密性，並僅得用於使用本服務，不應揭露、讓與或將其簡訊碼提供予任何第三人，或供第三人有償或無償使用，請您同意以下事項： 
                        <ul>
                            <li>( 1 )	當會員依照本系統規定方式正確登入時所進行之一切行動，無論是否由本人親自操作，一律視為會員本人使用操作。</li>
                            <li>( 2 )	會員有妥善自行保管簡訊碼和保密的義務，對於登入特定帳號並使用本服務之行為，均由持有該帳號和簡訊碼之會員負責。</li>
                            <li>( 3 )	會員帳號、密碼及會員權益均僅供會員本人單獨使用及持有，不得轉借、轉讓他人或與他人共用，因此致生之損害，會員應自行全權負責，與本公司無涉。</li>
                            <li>( 4 )	如會員專用帳號有遭盜用、不當使用、不法使用或其他本公司或本系統無法辯識是否為會員本人親自使用之情況時，因此致生之損害，會員應自行全權負責，與本公司無涉。</li>
                            <li>( 5 )	會員如果發現或懷疑其帳號和密碼恐遭第三人冒用或不當使用，會員應立即通知本公司，以利本公司及時採取適當的因應措施；但上述因應措施不得解釋為本公司因此而明示或默示對會員負有任何形式之賠償或補償義務。</li>
                        </ul>
                    </li>
                    <li>
                        2. 您擔保並承諾於房東模式下所編輯刊登之房源訊息均為真實，內容不得有 任何虛偽不實或誇大隱匿等不當與不法之處，包括但不限於房源本身、房 源狀況、房源介紹等相關資訊之真實性;如您編輯刊登之房源涉及或有涉 及前述不實內容之虞時，本公司將有權為下列處理:
                        <ul>
                            <li>( 1 )	透過系統強制下架您刊登之不實房源資訊，並禁止再行張貼;經下架 之房源如於系統下架前有會員下定付款，本平台有權將已收取款項全 數退還下定會員。</li>
                            <li>( 2 )	暫時停止您部分或全部會員權限。</li>
                            <li>( 3 )	永久停權或註銷您的會員帳戶。</li>
                            <li>( 4 )	如因您刊登不實房源資訊造成本公司受有相關損害或損失，本公司保 留向您請求賠償全部損害或損失之權利。</li>
                        </ul>
                    </li>
                    <li>
                        3. 您理解並同意於房客模式下所下定或房東模式下刊登之房源，如經本系統 與本公司合理判定屬於異常房源，包括系統錯誤顯示、不實房源，為保護 您與其他會員及本平台的權益並避免紛爭，您同意無條件配合本平台進行 退訂退款作業。
                    </li>
                    <li>
                        4. 您聲明並承諾如下事項:
                        <ul>
                            <li>( 1 )	遵守中華民國(台灣)相關法規，絕不為任何非法目的或以任何非法方式使用本服務；若係於中華民國(台灣)以外國家或地區使用，應承諾遵守使用行為所在之國家或地區之法令。</li>
                            <li>( 2 )	保證不會利用本服務從事侵害他人權益、違法或其他不符本服務所提供的使用目的等不當之行為。</li>
                            <li>( 3 )	保證不使用不適當之技術方法操控本服務、干擾本服務之軟硬體系統設備或複製、改造或公開傳輸本公司為提供本服務所使用之軟體、程式、資料庫及應用程式介面，及使用逆向工程、拆解或其他方法以分析上開軟體、程式、資料庫及應用程式介面。</li>
                            <li>( 4 )	保證不從事其他妨礙本服務之正常營運或本公司認為不適當之行為。</li>
                        </ul>
                    </li>
                    <li>
                        5. 本公司保留得依本服務實際執行情形，增加、修改或終止相關服務，並選擇最適方式告知會員之權利。您同意發生下列情形之一時，本公司有權可以暫停提供本服務：
                        <ul>
                            <li>( 1 )	本系統需進行必要更新、修正與維護時。</li>
                            <li>( 2 )	本系統由於天災等不可抗力之因素或其他不可歸責事由致本公司或本系統無法提供本服務時。</li>
                            <li>( 3 )	本公司裁量認定使用者使用本服務，已違反法律、本條款或其他要求。</li>
                        </ul>
                    </li>
                    <li>
                        6. 您理解並同意下述對於相關智慧財產權保護之內容:
                        <ul>
                            <li>( 1 )	本系統所有內容，包括但不限於著作、圖片、檔案、資訊、程式設計、介面、URL、商標或標識、資料庫等，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等所有權及權利，均屬於本公司或授權本公司使用之合法權利人所有。任何人不得逕自使用、修改、重製、公開播送、改作、散佈、發行、公開發表、進行還原工程、解編或反向組譯。</li>
                            <li>( 2 )	承上，如有侵害上開權利，應對本公司負相關損害賠償責任；若會員有涉及侵權之情事，本公司有權可暫停涉嫌會員之全部或部份服務。</li>
                        </ul>
                    </li>
                    <li>
                        7. 您理解並同意致生交易款項之原因事實及其交易關係，僅存在於房東方會員與房客方會員間，本系統僅依雙方會員之指示、同意與委託提供服務。雙方會員間所涉及債之關係，其權利義務關係僅存在於雙方會員之間，與本公司或本系統無涉。會員使用本系統不代表本系統對於各該交易之履行有任何明示或默示之保證或承諾。
                    </li>
                    <li>
                        8. 您同意若因本服務產生請求或爭議時，以下列方式為處理:
                        <ul>
                            <li>( 1 )	您同意先向本公司為反應與溝通，本公司之目標在於瞭解並回應您之疑慮，並提出中立且具成本效益、得以迅速解決爭議之建議方法。</li>
                            <li>( 2 )	若上開建議方法無法滿足您的需求，您同意因本條款所生或與本條款有關之任何請求或爭議，應以中華民國(台灣)法律為準據法。因本服務條款所發生的訴訟，以台灣台北地方法院為第一審管轄法院。</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="title-block" style="margin-top: 122px">
                <h1>隱私權政策</h1>
                <span class="update-date">更新於 2020 - 07 - 04</span>
                <div class="description">
                    為了讓您能夠安心的使用本系統的各項服務與資訊，特此說明本系統之隱私權保護政策，以保障您的權益，請您詳閱下列內容
                </div>
            </div>
            <div class="content-block">
                <h2>隱私權政策聲明</h2>
                <ul class="list">
                    <li>
                        當您於本系統註冊或進入服務後，您將被視為已同意「隱私權政策」的所有條款和條件。意即您同意並接受本隱私權聲明政策，本系統將以相關條款和條件收集、使用和以其他形式運用您的個人資料；如您決定不向本系統提供您的個人資料，本系統將無法向您提供任何服務。隱私權政策經過修訂、更改或更新而生效之後，如您未停止、或您繼續進入或使用服務的行為，也將被視為已接受本隱私權政策及其修訂、更改或更新。如對於本隱私權政策相關事項有任何疑問，歡迎您與本公司聯絡。
                    </li>
                </ul>
            </div>
             <div class="content-block">
                <h2>隱私權政策適用範圍</h2>
                <ul class="list">
                    <li>
                        本隱私權聲明及其所包含之告知事項，僅適用於本公司所有及營運的本系統。本隱私權政策不適用於本系統以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。故在此聲明；本公司及本系統對於其他網站或線上資源的隱私權政策與隱私設定，不負擔任何責任。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>個人資料蒐集、 處理及利用方式</h2>
                <ul class="list">
                    <li>
                        1. 當您註冊或進入本服務時，本系統會蒐集您的個人資料，並依據本隱私權政策，對於您提供給本公司的任何資訊內容，採取最為適當的使用；可能蒐集的資訊種類如下，包括但不限於:
                        <ul>
                            <li>( 1 )	用戶填寫或提供之個人資訊:例如姓名、電話號碼、電子郵件地址、出生年月日、身分證號碼等。</li>
                            <li>( 2 )	本系統運作蒐集之資訊:當您透過網路進入或使用本系統，本系統會運作使用某些技術，蒐集您的電腦、手機、或其他通訊設備傳送給本系統的資訊，該資訊包含但不限於:(1)IP位置、設備資訊，例如位置、網路資訊。(2)用戶名稱及密碼。</li>
                        </ul>
                    </li>
                    <li>
                        2. 本系統蒐集個人資料可能之目的如下:
                        <ul>
                            <li>( 1 )	會員註冊程序，與您建立並保有負責任的商業關係。</li>
                            <li>( 2 )	會員進入或使用本系統所需之驗證程序。</li>
                            <li>( 3 )	提供特定服務所需。</li>
                            <li>( 4 )	確保本公司符合相關法令規範要求。</li>
                            <li>( 5 )	分析會員對本系統之使用情形，以提供系統維護、更新、升級、偏好或客製化開發所需。</li>
                        </ul>
                    </li>
                    <li>
                        3. 非經您書面同意，本系統不會將個人資料用於上開目的以外之其他用途。僅於本聲明範圍內為運用，絕不會任意透露、出售、交換、或出租給其他第三人、單位及團體，並且嚴禁內部人員私自使用這些資料。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>資訊保護措施與聲明</h2>
                <ul class="list">
                    <li>
                        1. 您所提供的個人資料，本公司將以合於產業標準之合理技術及程序，防止個人資料洩露或遭未經授權的存取，並在提供個人資料的過程中避免上述風險發生，提供管理及保護。
                    </li>
                    <li>
                        2. 本系統主機均設有相關的各項資訊安全設備及必要防護措施，加以保護本系統及您的個人資料，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。
                    </li>
                    <li>
                        3. 惟本公司與本系統無法保證您的個人資料，於任何情形下均不會被駭客或任何電腦專家的攻擊而存取、揭露、更改或銷毀。
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>個人資料本人之權利</h2>
                <ul class="list">
                    <li>
                        1. 就本系統所蒐集、處理和利用的您的個人資料，您可以行使本隱私權政策所規定的權利，惟於特定情形下本系統可能無法繼續提供服務給您。
                    </li>
                    <li>
                        2. 您可以依據相關法律以及本隱私權政策行使或要求本公司為以下內容:
                        <ul>
                            <li>( 1 )	查詢或請求閱覽本系統所蒐集的個人資料。</li>
                            <li>( 2 )	補充或更正本系統蒐集的個人資料。</li>
                            <li>( 3 )	請求本系統停止繼續蒐集、處理與利用其已蒐集的個人資料。</li>
                            <li>( 4 )	請求刪除本系統蒐集的個人資料。</li>
                        </ul>
                    </li>
                    <li>
                        3. 惟本公司得因下列情事考量，就您所提出之上開所列舉的權利行使請求為是否同意的決定:
                        <ul>
                            <li>( 1 )	有妨害國家安全、外交和軍事機密，整體經濟利益或者其他重大國家利益之虞。</li>
                            <li>( 2 )	有妨害公務人員執行法定職務之虞。</li>
                            <li>( 3 )	有妨害本公司及本系統或第三方的重大利益者之虞。</li>
                            <li>( 4 )	因執行職務或履行法定義務所必要。</li>
                            <li>( 5 )	已取得您書面同意。</li>
                            <li>( 6 )	對於您個人資料的正確性存有爭議，且該爭議已經註明者。</li>
                        </ul>
                    </li>
                    <li>
                        4. 除下列情形外，本公司絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關。
                        <ul>
                            <li>( 1 )	提供本服務所必要或已取得您書面同意。</li>
                            <li>( 2 )	法律明文規定。</li>
                            <li>( 3 )	與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</li>
                            <li>( 4 )	當您使用本系統有違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
                            <li>( 5 )	有利於您的權益者。</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="content-block">
                <h2>隱私權保護政策之修正</h2>
                <ul class="list">
                    <li>
                        1. 您同意本系統得為符合法例條規的變更、個人資訊之收集與使用政策、功能或技術異動，隨時對本隱私權聲明進行修正。
                    </li>
                    <li>
                        2. 本系統作出新的修正之際，如有改變蒐集或使用個人資訊的方式，變更事項將會發布於本系統或本隱私權政策或其他本公司頁面，不再另行通知個別會員，請您密切注意相關修正內容。
                    </li>
                    <li>
                        3. 本公司於本系統或本隱私權政策或其他本公司頁面為更新修正發布後，倘您仍繼續使用本系統，即表示您已閱讀、瞭解並同意接受本隱私權政策之修正，並受修改後的隱私權政策所約束。
                    </li>
                </ul>
            </div>
        </div>
        <footer-comp></footer-comp>
    </div>
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
    mounted () {
        this.$analytics.logEvent("隱私權與政策", {
            screen_name: "隱私權與政策"
        });
    },
    components: {
        'header-comp': Header,
        'footer-comp': Footer
    }
}
</script>
<style lang="scss" scoped>
    .private-and-policy{
        background-color: #f6f6f6;
        .private-and-policy-wrap{
            padding: 153px 200px 122px;
            position: relative;
            .title-block{
                position: relative;
                margin-bottom: 40px;
                h1{
                    font-size: 36px;
                    margin-bottom: 12px;
                }
                h1:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -26px;
                    height: 3px;
                    width: 60px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .update-date{
                    position: absolute;
                    color: #a8a5a4;
                    top: 10px;
                    right: 0px;
                }
                .description{
                    width: 660px;
                    font-weight: 300;
                    line-height: 1.71;
                }
            }
            .content-block{
                background-color: #ffffff;
                padding: 24px 28px;
                margin-bottom: 24px;
                border-radius: 8px;
                border: solid 1px #f0f0f0;
                h2{
                    font-size: 20px;
                    margin-bottom: 8px;
                }
                .description{
                    color: #a8a5a4;
                    line-height: 1.71;
                }
                .list:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -23px;
                    height: 2px;
                    width: 24px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .list{
                    position: relative;
                    margin-top: 42px;
                    width: 660px;
                    li{
                        line-height: 1.71;
                        font-weight: 300;
                        margin-bottom: 16px;
                        > ul{
                            position: relative;
                            margin-top: 16px;
                            margin-left: 20px;
                        }
                    }
                    
                }
            }
        }
    }
    @media screen and (max-width: 500px) {
        .private-and-policy{
            background-color: #f6f6f6;
            .private-and-policy-wrap{
                padding: 120px 20px 40px;
                .title-block{
                    h1{
                        font-size: 28px;
                        margin-bottom: 16px;
                    }
                    .update-date{
                        position: relative;
                        display: block;
                        margin-bottom: 18px;
                        top: 0px;
                    }
                    .description{
                        width: 100%;
                    }
                }
                .content-block{
                    padding: 20px;
                    .list{
                        width: 100%;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 500px) {
        .private-and-policy{
            .private-and-policy-wrap{
                padding: 100px 20px 40px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/PrivateAndPolicy.vue